/**
 * @file
 * Footer scripts.
 */

(function footerScript($, Drupal, _) {
  'use strict';

  /*
  * Full viewport height content/sticky footer
  */
  Drupal.behaviors.footerSticky = {
    attach: function (context) {
      function setHeight() {
        var $siteContent = $('.site__content', context);
        var siteContentHeight = parseInt($siteContent.height());
        var siteHeight = parseInt($('.site', context).height());
        var viewportHeight = window.innerHeight;

        if (siteHeight < viewportHeight) {
          $siteContent
            .css('min-height', siteContentHeight + (viewportHeight - siteHeight))
            .addClass('site__content--full-height');
        }
      }

      // Need setHeight() to run after React is injected onLoad.
      setTimeout(function () {
        setHeight();
      }, 0);

      $(window).resize(_.debounce(function () {
        setHeight();
      }, 50));

      if ($('.footer-flush', context).length) {
        $('.footer', context).addClass('footer--no-margin');
      }
    }
  };

}(jQuery, Drupal, _));

(function languageSwitchScript($, Drupal, _) {
  'use strict';

  /*
   * Language select
   */
  Drupal.behaviors.languageSelectSwitcher = {
    attach: function (context) {
      var $languageSelect = $('.js-language-block', context);

      // Bind change event to select.
      $languageSelect.on('change', function () {
        var url = $(this).val(); // get selected value
        if (url) { // require a URL
          window.location = url; // redirect
        }
        return false;
      });
    }
  };

}(jQuery, Drupal, _));


(function footerCountryCodedLinks($, Drupal, _) {
  'use strict';

  /**
   * Extract the geoip country code cookie.
   *
   * @return {Object}
   *   An object with the following for the first tracker found:
   *   'name': The name of the cookie.
   *   'value': The current value of the cookie, null if not set.
   */
  var getGeoIpCountryCodeCookie = function () {
    var cookie = {
      name: '_ss_country_code',
      value: null
    };

    if ('cookie' in $) {
      var cookieValue = $.cookie(cookie.name);
      if (typeof cookieValue !== 'undefined') {
        cookie.value = cookieValue;
      }
    }

    return cookie;
  };


  /**
   * Footer country coded links.
   */
  Drupal.behaviors.footerCountryCodedLinks = {
    attach: function (context) {
      var country_cookie = getGeoIpCountryCodeCookie();
      if (country_cookie.value) {
        $('.footer__menu__item[data-country-code*=' + country_cookie.value.toUpperCase() + ']', context).show();
      }
    }
  };

}(jQuery, Drupal, _));
